import dynamic from 'next/dynamic';
import { Container } from '../../components';
import styles from './mvp-comment.module.css';
import commonStyles from './mvp.module.css';

const DynamicCommentsList = dynamic(
  () => import('../../components/comments-list'),
  {
    ssr: true,
  },
);

export default function MVPComments() {
  return (
    <Container>
      <section className={styles.clients}>
        <h2 className={commonStyles.h2}>Reviews from our clients</h2>
        <DynamicCommentsList />
      </section>
    </Container>
  );
}
